import { api } from '../../DefaultService';
import {
  IFaceRecognitionEventProps,
  IFaceRecognitionEventSimpleProps,
} from './types';
import { IPaginationParams } from '../../types';

export const FACE_RECOGNITION_EVENT_ENDPOINT = 'v1/events/faceRecognition';

export const getFaceRecognitionEventByIdAsync = async (
  id: number,
): Promise<IFaceRecognitionEventProps> => {
  return await api
    .get(`${FACE_RECOGNITION_EVENT_ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllFaceRecognitionEventByLicenseAsync = async (
  params: IPaginationParams,
): Promise<IFaceRecognitionEventSimpleProps[]> => {
  return await api
    .get(`${FACE_RECOGNITION_EVENT_ENDPOINT}/getAllByLicense`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllFaceRecognitionEventCountByLicenseAsync =
  async (): Promise<number> => {
    return await api
      .get(`${FACE_RECOGNITION_EVENT_ENDPOINT}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };
